module.exports = __webpack_public_path__ + "static/media/calendario.093f2e32.svg";